import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Mail, Loader2 } from "lucide-react";

export const TestWelcomeEmailButton = () => {
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/test-welcome-email", { origin_url: window.location.origin });
      toast.success(`Test welcome email sent to ${data.to}`);
    } catch (e) { toast.error(apiError(e)); }
    finally { setBusy(false); }
  };
  return (
    <Card className="mb-5 p-6" data-testid="test-welcome-email-card">
      <h3 className="font-semibold text-slate-900">Welcome email</h3>
      <p className="mt-1 text-sm text-slate-500">New loan officers get this email when their account is approved. Send a copy to your own inbox to see it.</p>
      <Button variant="outline" className="mt-4" onClick={send} disabled={busy} data-testid="send-test-welcome-email-btn">
        {busy ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <Mail className="mr-1.5 h-4 w-4" />} Send test welcome email
      </Button>
    </Card>
  );
};
